import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './projects.css';

const officeZoneImages = [
  { id: 1, thumbnail: '../images/interior4/OFIS.png', fullImage: '../images/interior4/OFIS.png' },
  { id: 2, thumbnail: '../images/interior4/OFIS_2.png', fullImage: '../images/interior4/OFIS_2.png' },
  { id: 3, thumbnail: '../images/interior4/OPEN SPE.png', fullImage: '../images/interior4/OPEN SPE.png' },
  { id: 4, thumbnail: '../images/interior4/OPEN_SPACE.png', fullImage: '../images/interior4/OPEN_SPACE.png' },
  { id: 5, thumbnail: '../images/interior4/OPEN_SPACE1.png', fullImage: '../images/interior4/OPEN_SPACE1.png' },
  { id: 6, thumbnail: '../images/interior4/OPEN_SPACE2.png', fullImage: '../images/interior4/OPEN_SPACE2.png' },
  { id: 7, thumbnail: '../images/interior4/OPEN_SPACE3.png', fullImage: '../images/interior4/OPEN_SPACE3.png' },
  { id: 8, thumbnail: '../images/interior4/OPEN_SPACE4.png', fullImage: '../images/interior4/OPEN_SPACE4.png' },
  { id: 9, thumbnail: '../images/interior4/OPEN_SPACE5.png', fullImage: '../images/interior4/OPEN_SPACE5.png' },
  { id: 10, thumbnail: '../images/interior4/OPEN_SPACE6.png', fullImage: '../images/interior4/OPEN_SPACE6.png' },
  { id: 11, thumbnail: '../images/interior4/OPEN_SPACE7.png', fullImage: '../images/interior4/OPEN_SPACE7.png' },
  { id: 12, thumbnail: '../images/interior4/OPEN_SPACE8.png', fullImage: '../images/interior4/OPEN_SPACE8.png' },
  // Add more images as needed
];

function OfficeZone() {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/interior-designs');
  };

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  const handleClose = () => {
    setSelectedImageIndex(null);
  };

  const handlePrev = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : officeZoneImages.length - 1));
  };

  const handleNext = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex < officeZoneImages.length - 1 ? prevIndex + 1 : 0));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (selectedImageIndex !== null) {
        if (event.key === 'ArrowLeft') {
          handlePrev();
        } else if (event.key === 'ArrowRight') {
          handleNext();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImageIndex]);

  return (
    <div className="project-detail">
      <button className="back-button" onClick={handleBack}>НАЗАД ВО ВСЕ ИНТЕРЬЕРЫ</button>
      <div className="project-detail-grid">
        {officeZoneImages.map((image, index) => (
          <div key={image.id} className="project-detail-item">
            <img
              src={image.thumbnail}
              alt={`Office Zone Image ${index + 1}`}
              onClick={() => handleImageClick(index)}
            />
          </div>
        ))}
      </div>

      <button className="back-button back-button-end" onClick={handleBack}>НАЗАД ВО ВСЕ ИНТЕРЬЕРЫ</button>

      {selectedImageIndex !== null && (
        <div className="project-popup" onClick={handleClose}>
          <div className="project-popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleClose}>X</button>
            <button className="nav-button left" onClick={handlePrev}>&lt;</button>
            <img src={officeZoneImages[selectedImageIndex].fullImage} alt={`Office Zone Image ${selectedImageIndex + 1}`} />
            <button className="nav-button right" onClick={handleNext}>&gt;</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default OfficeZone; 